import { t } from 'i18next';

import { ErrorResponseErrorItemCodeSharedView } from '../../../../../typings/api/skymap/rest/v1/.common';

export const translations = (): Record<ErrorResponseErrorItemCodeSharedView, string> => ({
  'shared_view:comment_not_found': t('sharedView.commentNotFound', {
    ns: 'apiErrorCodes',
    defaultValue: 'Kommentaren kunde inte hittas.',
  }),
  'shared_view:dynamic_asset_not_found': t('sharedView.dynamicAssetNotFound', {
    ns: 'apiErrorCodes',
    defaultValue: 'Objektet är inte kopplat till den delade vyn.',
  }),
  'shared_view:file_not_found': t('sharedView.fileNotFound', {
    ns: 'apiErrorCodes',
    defaultValue: 'Filen kunde inte hittas.',
  }),
  'shared_view:file_version_not_found': t('sharedView.fileVersionNotFound', {
    ns: 'apiErrorCodes',
    defaultValue: 'Filversionen kunde inte hittas.',
  }),
  'shared_view:not_found': t('sharedView.notFound', {
    ns: 'apiErrorCodes',
    defaultValue: 'Den delade vyn kunde inte hittas.',
  }),
});
